/* Seneca product modal carousel v2 */
if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.senecaMediaItems = [];
      this.senecaMediaIndex = 0;
      this.querySelectorAll('[data-seneca-modal-nav]').forEach((control) => {
        control.addEventListener('pointerup', (event) => {
          event.preventDefault();
          event.stopPropagation();
        });
        control.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.senecaStepCarousel(control.dataset.senecaModalNav === 'next' ? 1 : -1);
        });
      });
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight') { event.preventDefault(); this.senecaStepCarousel(1); }
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.senecaStepCarousel(-1); }
      });
    }
    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }
    showActiveMedia() {
      this.senecaMediaItems = Array.from(this.querySelectorAll('.product-media-modal__content > [data-media-id]'));
      if (!this.senecaMediaItems.length) return;
      const openedMediaId = this.openedBy && this.openedBy.getAttribute('data-media-id');
      const openedIndex = this.senecaMediaItems.findIndex((item) => item.getAttribute('data-media-id') === openedMediaId);
      this.senecaMediaIndex = openedIndex >= 0 ? openedIndex : 0;
      this.renderActiveMedia();
    }
    renderActiveMedia() {
      if (!this.senecaMediaItems.length) return;
      this.senecaMediaItems.forEach((item, index) => {
        const active = index === this.senecaMediaIndex;
        item.classList.toggle('active', active);
        item.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      this.querySelectorAll('[data-seneca-modal-nav]').forEach((control) => {
        const disabled = this.senecaMediaItems.length < 2;
        control.hidden = disabled;
        control.disabled = disabled;
      });
      const activeMedia = this.senecaMediaItems[this.senecaMediaIndex];
      activeMedia.scrollIntoView({ block: 'center', inline: 'center' });
      if (activeMedia.nodeName === 'DEFERRED-MEDIA') {
        const template = activeMedia.querySelector('template');
        const content = template ? template.content : null;
        if (content && (content.querySelector('.js-youtube') || content.querySelector('.js-vimeo'))) activeMedia.loadContent();
      }
    }
    senecaStepCarousel(direction) {
      if (!this.senecaMediaItems.length) this.showActiveMedia();
      if (!this.senecaMediaItems.length) return;
      this.senecaMediaIndex = (this.senecaMediaIndex + direction + this.senecaMediaItems.length) % this.senecaMediaItems.length;
      this.renderActiveMedia();
    }
  });
}
